import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../layout/Layout";

const Auth = lazy(() => import("../components/auth/AuthLayout"));
const Error404 = lazy(() => import("../components/error/Error404"));
const Maintainance = lazy(() => import("../components/error/Maintainance"));

function LandingRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Auth />} />
        <Route path="/404" element={<Error404 />} />
        <Route path="/maintainance" element={<Maintainance />} />
      </Route>
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}

export default LandingRoutes;
